import { render, staticRenderFns } from "./v-firebaseui.vue?vue&type=template&id=d49a6594&scoped=true&"
import script from "./v-firebaseui.vue?vue&type=script&lang=js&"
export * from "./v-firebaseui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49a6594",
  null
  
)

export default component.exports